<template>
  <div class="i" :class="inputClasses">
    <label v-if="title" class="i__label" :for="`i-${name}`">{{ title }}</label>
    <div class="i__input-container">
      <select :id="`i-${name}`" v-model.trim="inputValue" class="i__input" tabindex="0" :name="name">
        <option value="">{{ placeholder || '' }}</option>
        <!-- Select options -->
        <template v-for="(option, i) in options">
          <option v-if="option && option.value && option.title" :key="`SelectOption${i}`" :value="option.value">
            {{ option.title }}
          </option>
        </template>
      </select>
      <p v-if="!inputValue" class="i__select-label">{{ placeholder || $t('general.select') }}</p>
      <svg-arrow-down class="svg-fill i__select-icon" />
    </div>
    <p v-show="error" class="i__msg">* {{ error }}</p>
  </div>
</template>

<script>
import InputMixin from '../../../mixins/input'
import SvgArrowDown from '../../../assets/svg/arrowDown.svg?inline'

export default {
  components: {
    'svg-arrow-down': SvgArrowDown,
  },
  data() {
    return {
      /**
       * Input type must be "select"
       */
      type: 'select',
    }
  },
  mixins: [InputMixin],
  props: {
    /**
     * Select options
     */
    options: {
      default: () => [],
      type: Array,
    },

    /**
     * Default input value
     */
    value: {
      default: '',
      type: [String, Number],
    },
  },
}
</script>
